export var AvailabilityType;
(function (AvailabilityType) {
    /** Missing type due to an error. */
    AvailabilityType["UNSPECIFIED_AVAILABILITY_OPTION"] = "UNSPECIFIED_AVAILABILITY_OPTION";
    /** Available all the time. */
    AvailabilityType["ALWAYS_AVAILABLE"] = "ALWAYS_AVAILABLE";
    /** Available on specific days and times throughout the week. */
    AvailabilityType["WEEKLY_SCHEDULE"] = "WEEKLY_SCHEDULE";
    /** Available during a specific time range. */
    AvailabilityType["TIMESTAMP_RANGES"] = "TIMESTAMP_RANGES";
})(AvailabilityType || (AvailabilityType = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    /** Monday. */
    DayOfWeek["MON"] = "MON";
    /** Tuesday. */
    DayOfWeek["TUE"] = "TUE";
    /** Wednesday. */
    DayOfWeek["WED"] = "WED";
    /** Thursday. */
    DayOfWeek["THU"] = "THU";
    /** Friday. */
    DayOfWeek["FRI"] = "FRI";
    /** Saturday. */
    DayOfWeek["SAT"] = "SAT";
    /** Sunday. */
    DayOfWeek["SUN"] = "SUN";
})(DayOfWeek || (DayOfWeek = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var AvailabilityStatus;
(function (AvailabilityStatus) {
    /** Unknown availability status. */
    AvailabilityStatus["UNKNOWN_AVAILABILITY_STATUS"] = "UNKNOWN_AVAILABILITY_STATUS";
    /** Available. */
    AvailabilityStatus["AVAILABLE"] = "AVAILABLE";
    /** Unavailable. */
    AvailabilityStatus["UNAVAILABLE"] = "UNAVAILABLE";
})(AvailabilityStatus || (AvailabilityStatus = {}));
/** Where the extra text should be displayed: before, after or instead of the actual address. */
export var PlacementType;
(function (PlacementType) {
    PlacementType["BEFORE"] = "BEFORE";
    PlacementType["AFTER"] = "AFTER";
    PlacementType["REPLACE"] = "REPLACE";
})(PlacementType || (PlacementType = {}));
/** Enumerates the days of the week. */
export var V4DayOfWeek;
(function (V4DayOfWeek) {
    V4DayOfWeek["MONDAY"] = "MONDAY";
    V4DayOfWeek["TUESDAY"] = "TUESDAY";
    V4DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    V4DayOfWeek["THURSDAY"] = "THURSDAY";
    V4DayOfWeek["FRIDAY"] = "FRIDAY";
    V4DayOfWeek["SATURDAY"] = "SATURDAY";
    V4DayOfWeek["SUNDAY"] = "SUNDAY";
})(V4DayOfWeek || (V4DayOfWeek = {}));
export var ResolutionMethod;
(function (ResolutionMethod) {
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod || (ResolutionMethod = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map